import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Exams|Violations|Modal|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Exam,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryExamViolationsModal';
export type SPCandidateHistoryExamViolationsModalLocNames =
	| `${LocNameStart}Title`
	| `${LocNameStart}LabelExam`
	| `${LocNameStart}LabelExamCode`
	| `${LocNameStart}LabelExamDate`
	| `${LocNameStart}LabelViolation`
	| `${LocNameStart}ContentInstructions`
	| `${LocNameStart}LabelComments`
	| `${LocNameStart}ErrorCommentsRequired`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonUpdate`
	| `${LocNameStart}NotificationSuccess`
	| `${LocNameStart}NotificationFailure`;

export const spCandidateHistoryExamViolationsModalLocs: LocDefs<SPCandidateHistoryExamViolationsModalLocNames> =
	{
		SPCandidateHistoryExamViolationsModalTitle: {
			defaultValue: 'Create Exam Violation',
			description: 'Modal Title',
			displayPath: `${pathStart}Modal Title`,
			displayType: 'Title',
			legacyName: 'Exam/CreateExamViolation.Modal.Title.CreateExamViolation',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsModalLabelExam: {
			defaultValue: 'Exam',
			description: 'Label for: Exam.',
			displayPath: `${pathStart}Exam`,
			displayType: 'Label',
			legacyName: 'Exam/CreateExamViolation.Modal.FieldLabel.Exam',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsModalLabelExamCode: {
			defaultValue: 'Exam Code',
			description: 'Label for: Exam Code.',
			displayPath: `${pathStart}Exam Code`,
			displayType: 'Label',
			legacyName: 'Exam/CreateExamViolation.Modal.FieldLabel.ExamCode',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsModalLabelExamDate: {
			defaultValue: 'Exam Date',
			description: 'Label for: Exam Date.',
			displayPath: `${pathStart}Exam Date`,
			displayType: 'Label',
			legacyName: 'Exam/CreateExamViolation.Modal.FieldLabel.ExamDate',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsModalLabelViolation: {
			defaultValue: 'Violation',
			description: 'Label for: Violation.',
			displayPath: `${pathStart}Violation`,
			displayType: 'Label',
			legacyName: 'Exam/CreateExamViolation.Modal.FieldLabel.Violation',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsModalContentInstructions: {
			defaultValue: 'Instructions',
			description: 'Instructions before the comments.',
			displayPath: `${pathStart}Instructions`,
			displayType: 'Content',
			legacyName: 'Exam/CreateExamViolation.Modal.Content.Instructions',
			...sharedProperties,
			htmlAllowed: true,
		},
		SPCandidateHistoryExamViolationsModalLabelComments: {
			defaultValue: 'Comments',
			description: 'Label for: Comments.',
			displayPath: `${pathStart}Comments`,
			displayType: 'Label',
			legacyName: 'Exam/CreateExamViolation.Modal.FieldLabel.Comments',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsModalErrorCommentsRequired: {
			defaultValue: 'Comments are required',
			description: 'Error for: Comments are required.',
			displayPath: `${pathStart}Comments are required`,
			displayType: 'Error',
			legacyName: 'Exam/CreateExamViolation.Modal.FieldError.CommentsRequired',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsModalButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button.',
			displayPath: `${pathStart}Cancel`,
			displayType: 'Button',
			legacyName: 'Exam/CreateExamViolation.Modal.Button.Cancel',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsModalButtonUpdate: {
			defaultValue: 'Update/Confirm',
			description: 'Update/Confirm button.',
			displayPath: `${pathStart}Update/Confirm`,
			displayType: 'Button',
			legacyName: 'Exam/CreateExamViolation.Modal.Button.Update',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsModalNotificationSuccess: {
			defaultValue: 'Your request has successfully been submitted.',
			description: 'Success notification.',
			displayPath: `${pathStart}Success`,
			displayType: 'Notification',
			legacyName: 'Exam/CreateExamViolation.Modal.NotificationMessage.Success',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsModalNotificationFailure: {
			defaultValue: 'There was an error submitting your request.',
			description: 'Failure notification.',
			displayPath: `${pathStart}Failure`,
			displayType: 'Notification',
			legacyName: 'Exam/CreateExamViolation.Modal.NotificationMessage.Failure',
			...sharedProperties,
		},
	};

export type SPCandidateHistoryExamViolationsModalLocType =
	LocMap<SPCandidateHistoryExamViolationsModalLocNames>;
